import { Fragment } from 'preact';
import { useLayoutEffect, useState } from 'preact/hooks';
import { getNonce, supportsCSSStyleSheetReplace } from '@/utils';
import { useManagerStore } from '../stores/ManagerStore';

// uncomment if working on styles locally,
//leaving this in the production build may cause weird integration issues
//do not forgot to comment it again
//also comment out the base css in the Styles component if you're working on css
// if (process.env.NODE_ENV === 'development') {
// 	import('@/assets/css/survey-base.css');
// 	import('@/assets/css/themes/survey-default.css');
// }

function updateSheet(targetSheet, css) {
	targetSheet.replaceSync(css);

	if (document.adoptedStyleSheets.indexOf(targetSheet) === -1) {
		document.adoptedStyleSheets = [...document.adoptedStyleSheets, targetSheet];
	}
}

export default function Styles({ cssDomain, cacheDomain, customDomain }) {
	const { styles = {}, themes = [], formKeys = [] } = useManagerStore();
	const [sheet] = useState(() => {
		if (supportsCSSStyleSheetReplace()) {
			return new CSSStyleSheet();
		}
		return null;
	});
	const [baseFailed, setBaseFailed] = useState(false);
	const { base = '', ...otherStyles } = styles;

	//if nonces are used add it to the inline styles just in case
	const nonceProp = getNonce('style') ? { nonce: getNonce('style') } : {};

	const css = `
		${base}
		${themes.map(theme => otherStyles?.[theme] ?? '').join(' ')}
		${formKeys.map(key => otherStyles?.[key] ?? '').join(' ')}
	`;

	useLayoutEffect(() => {
		if (sheet) {
			updateSheet(sheet, css);
		}
	}, [css, sheet]);

	if (sheet) {
		return null;
	}

	// fallback for browsers that don't support CSSStyleSheet
	if (!baseFailed) {
		return (
			<Fragment>
				<link
					rel="stylesheet"
					href={`https://${cssDomain}/css/survey-base.css`}
					onError={() => setBaseFailed(true)}
				/>
				{themes.map(theme => (
					<link
						rel="stylesheet"
						href={`https://${cssDomain}/css/themes/${theme}.css`}
					/>
				))}
				{formKeys.map(key => (
					<link
						rel="stylesheet"
						href={`https://${cacheDomain}/survey/public/custom-css/${key}?domain=${customDomain}`}
					/>
				))}
			</Fragment>
		);
	}

	// fallback for old csp policies
	return (
		<Fragment>
			<style {...nonceProp}>{css}</style>
		</Fragment>
	);
}
